import React from 'react'

import Kleber from '../../assets/images/polaroid-kleber.svg'
import Image from '../atoms/Image'

const Polaroid = ({ image, alt, caption }) => {
  return (
    <div className="polaroid">
      <Image className="polaroid-kleber" image={Kleber} />
      <Image
        className="polaroid-image"
        image={image}
        imageWidth="1000"
        imageHeight="1000"
        alt={alt}
      />
      <span className="polaroid-text">
        {caption && caption.length > 0 && caption}
      </span>
    </div>
  )
}

export default Polaroid
